import React, { useEffect, useState } from "react";
import { listQueue } from "@/lib/offlineQueue.js";
import { syncWhen } from "@/lib/huntDates.js";

const SYNC_KEY = "orignal2026.lastSync";

export function SyncBanner() {
  const [count, setCount] = useState(0);
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  const [syncing, setSyncing] = useState(false);
  const [stamp, setStamp] = useState(() => window.localStorage.getItem(SYNC_KEY) || "");

  async function refresh() {
    try {
      const items = await listQueue();
      setCount(items.length);
    } catch {
      setCount(0);
    }
  }

  useEffect(() => {
    refresh();
    const onChange = () => refresh();
    const onStart = () => setSyncing(true);
    const onDone = (event) => {
      setSyncing(false);
      setOnline(true);
      if (event.detail?.at) {
        window.localStorage.setItem(SYNC_KEY, event.detail.at);
        setStamp(event.detail.at);
      }
      refresh();
    };
    window.addEventListener("orignal-offline-change", onChange);
    window.addEventListener("orignal-sync-start", onStart);
    window.addEventListener("orignal-sync-done", onDone);
    window.addEventListener("online", () => setOnline(true));
    window.addEventListener("offline", () => setOnline(false));
    return () => {
      window.removeEventListener("orignal-offline-change", onChange);
      window.removeEventListener("orignal-sync-start", onStart);
      window.removeEventListener("orignal-sync-done", onDone);
    };
  }, []);

  const when = stamp ? syncWhen(stamp) : "";
  let line = "En ligne";
  if (syncing) line = "Synchronisation en cours…";
  else if (!online) line = `Hors ligne · Dernière synchro ${when || "—"}`;
  else if (count) line = "Données en attente";
  else if (when) line = `En ligne · Synchronisé à ${when} ✓`;
  return (
    <div className="og-sync" data-testid="sync-banner" data-online={online ? "1" : "0"}>
      <span>{line}</span>
      {count ? <span>{count} élément{count > 1 ? "s" : ""} à synchroniser</span> : null}
    </div>
  );
}
